<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                  <div class="card-header align-items-center border-bottom-dark px-0">
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Обнуление остатков
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-8 col-xl-7">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <p class="text-body mb-4">
                      Списывает остатки всех товаров на всех складах. Для каждой позиции
                      создаётся списание, как при инвентаризации, — история движений
                      сохраняется, но текущие остатки становятся нулевыми.
                    </p>

                    <div class="alert alert-warning" role="alert">
                      Действие затрагивает весь склад и не отменяется одной кнопкой.
                      Восстановить остатки можно только новым оприходованием.
                    </div>

                    <div v-if="result" class="alert" :class="resultClass" role="alert">
                      {{ result }}
                    </div>

                    <div v-if="!confirming">
                      <button
                        type="button"
                        class="btn btn-danger"
                        :disabled="running"
                        @click="confirming = true"
                      >
                        Обнулить остатки
                      </button>
                    </div>

                    <div v-else>
                      <p class="text-body font-weight-bold mb-3">
                        Обнулить остатки по всем складам?
                      </p>
                      <button
                        type="button"
                        class="btn btn-danger mr-2"
                        :disabled="running"
                        @click="resetStock"
                      >
                        {{ running ? "Обнуляю…" : "Да, обнулить" }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        :disabled="running"
                        @click="confirming = false"
                      >
                        Отмена
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      confirming: false,
      running: false,
      result: "",
      failed: false,
    };
  },
  computed: {
    resultClass() {
      return this.failed ? "alert-danger" : "alert-success";
    },
  },
  methods: {
    resetStock() {
      this.running = true;
      this.result = "";
      this.failed = false;

      var token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      axios
        .post("/api/admin/stock/reset", {}, config)
        .then((res) => {
          this.failed = res.data.status !== "Success";
          this.result = res.data.message;
        })
        .catch((error) => {
          this.failed = true;
          this.result =
            (error.response && error.response.data && error.response.data.message)
              ? error.response.data.message
              : "Не удалось обнулить остатки.";
        })
        .finally(() => {
          this.running = false;
          this.confirming = false;
        });
    },
  },
};
</script>
